var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16914 0.916795C0.93769 0.916795 0.702831 1.00441 0.527269 1.17526C0.175806 1.51728 0.175806 2.08282 0.527269 2.42484L7.10398 8.82483C7.27372 8.99002 7.5132 9.08329 7.74585 9.08329C7.97631 9.08329 8.20601 9.00166 8.38773 8.82483L14.9554 2.43304C15.3234 2.09606 15.3281 1.51717 14.9766 1.17515C14.6252 0.833128 14.044 0.833128 13.6925 1.17515L13.6923 1.17536L7.7576 6.9621L1.81079 1.17509C1.6349 1.00392 1.40005 0.916626 1.16892 0.916626L1.16914 0.916795Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.dc864096f180932c0b06727595f77349.svg";
export { ForwardRef as ReactComponent };